import React, { ReactNode, useState } from 'react';
import styles from './BaseBoxContent.module.scss';
import classNames from 'classnames/bind';

type Props = {
  children: ReactNode;
  expanded?:boolean;
  className?:string;
};
const cx = classNames.bind(styles);


export default function BaseBoxContent({expanded, children, className="" }: Props) {
  let header: ReactNode = null;
  let content: ReactNode = null;
  let footer: ReactNode = null;

  const [isExpanded, setExpanded] = useState(true)

  React.Children.forEach(children, (child) => {
    if (!React.isValidElement(child)) return;

    const slot = child.props['data-slot'];
    const inner = child.props.children;

    if (slot === 'header') header = inner;
    if (slot === 'content') content = inner;
    if (slot === 'footer') footer = inner;
  });

  return (
    <div className={cx('base-box-content', className)}>
        {header && <div className={cx({
            'box-content-child':true,
            'box-header':true
        })}>
            <div className={cx({
                'box-content-header':true
            })}>{header}</div>

            {
                expanded && <div className={cx({
                    'box-expanded':expanded,
                    'expanded':isExpanded
                })} onClick={()=>{setExpanded(!isExpanded)}}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 9L12 15L18 9" stroke="#F9FBFE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            }
        </div>}

        {
            isExpanded && <>
                {content && <div className={cx({
                    'box-content-child':true,
                    'box-content-content':true
                })}>{content}</div>}

                {footer && <div className={cx({
                    'box-content-child':true,
                    'box-content-footer':true
                })}>{footer}</div>}
            </>
        }


    </div>
  );
}